import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

const ExternalLink = ({
  id,
  href,
  titleId,
  content,
  onClick,
  noTarget,
  className,
  defaultMessage,
  titleDefaultMessage,
}) => {
  const intl = useIntl();
  return (
    <a
      href={href}
      onClick={onClick}
      className={className}
      target={noTarget ? "" : "_blank"}
      title={
        titleId && titleDefaultMessage
          ? intl.formatMessage({
              id: titleId,
              defaultMessage: titleDefaultMessage,
            })
          : ""
      }
      rel="noreferrer noopener"
    >
      {content || <FormattedMessage id={id} defaultMessage={defaultMessage} />}
    </a>
  );
};

export default ExternalLink;
